export default __webpack_public_path__ + "static/media/Padron_Damaso.729fb232.jpg";